<template>
  <div>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text fab v-on="on">
          <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="showResetPasswordDialog()">
        <v-list-item-title>Change password</v-list-item-title>
      </v-list-item>
      <v-list-item @click="deactivateConfirmation = true" v-if="canDeactivate">
        <v-list-item-title>Deactivate</v-list-item-title>
      </v-list-item>
      <v-list-item @click="activateAccount()" v-if="canActivate">
        <v-list-item-title>Reactivate</v-list-item-title>
      </v-list-item>
      <v-list-item @click="deleteConfirmation = true" v-if="userIsNotMe">
        <v-list-item-title>Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-dialog v-model="deleteConfirmation" max-width="290">
    <v-card>
      <v-card-title class="headline">Delete this user?</v-card-title>
      <v-card-text>Are you sure you would like to delete this user? They will no longer be able to access the system.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click.native="deleteConfirmation = false">Cancel</v-btn>
        <v-btn color="red darken-1" text @click.native="deleteAccount()">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="deactivateConfirmation" max-width="290">
    <v-card>
      <v-card-title class="headline">Deactivate user ?</v-card-title>
      <v-card-text>Deactivated users will not longer be able to access the system. You can reactive them later.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click.native="deactivateConfirmation = false">Cancel</v-btn>
        <v-btn color="red darken-1" text @click.native="deactivateAccount()">Deactivate</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    <app-edit-password-dialog :id="account.id" :show="editPassword" :onDismiss="dismissEditPassword" :onSubmit="onSubmitPassword"></app-edit-password-dialog>
  </div>
</template>
<script>
export default {
  props: ['account'],
  data () {
    return {
      editPassword: false,
      deleteConfirmation: false,
      deactivateConfirmation: false
    }
  },
  computed: {
    userIsNotMe () {
      return this.account.id !== this.$store.getters.user.id
    },
    canDeactivate () {
      return this.userIsNotMe && this.account.isActive
    },
    canActivate () {
      return this.userIsNotMe && !this.account.isActive
    }
  },
  methods: {
    dismissEditPassword () {
      this.editPassword = false
    },
    deleteAccount () {
      this.deleteConfirmation = false
      this.$store.dispatch('deleteAccount', this.account.id)
      this.$router.push('/accounts')
    },
    deactivateAccount () {
      this.deactivateConfirmation = false
      this.$store.dispatch('accounts/update', {
        id: this.account.id,
        isActive: false
      })
    },
    activateAccount () {
      this.deactivateConfirmation = false
      this.$store.dispatch('accounts/update', {
        id: this.account.id,
        isActive: true
      })
    },
    showResetPasswordDialog () {
      this.editPassword = true
    },
    onSubmitPassword (newPassword) {
      this.$store.dispatch('accounts/update', {
        id: this.account.id,
        password: newPassword
      })
    }
  }
}
</script>
